import { Spinner } from "@chakra-ui/react";
import { useEffect } from "react";
import { refresh } from "modules/members/api";
import { useNavigate } from "react-router-dom";
import { takeReturnPath } from "./returnPath";

const Success = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // get the URL parameters which will include the auth token
    const params = window.location.search;
    const urlParams = new URLSearchParams(params);
    const isExtension = urlParams.get("extension") === "true";

    try {
      if (isExtension) {
        // For Chrome extensions, post a message that the content script can capture
        console.log(
          window.postMessage(
            {
              source: "member-auth-extension",
              params: params,
            },
            window.location.origin,
          ),
        );
      } else if (window.opener) {
        // Original flow for regular web auth
        window.opener.postMessage({ params, source: "member-auth" });
        window.close();
      } else {
        // No opener means this tab was navigated to directly (e.g. a sandbox
        // access link, or a `?auth=` link that signed in without a popup);
        // window.close() is a no-op there and would hang on the spinner.
        // Wait for the session first, or the route guard sends a deep link
        // back to sign-in before the member counts as signed in.
        refresh()
          .catch(() => null)
          .then(() => navigate(takeReturnPath() ?? "/members"));
      }
    } catch (e) {
      console.error("Error in auth success handling:", e);
      // Try to close anyway
      setTimeout(() => window.close(), 2000);
    }
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Spinner />
      <p style={{ marginTop: "20px" }}>
        Authentication successful! This window will close automatically...
      </p>
    </div>
  );
};

export default Success;
